import { render, staticRenderFns } from "./AcademicDataTable.vue?vue&type=template&id=21eed57b&scoped=true&"
import script from "./AcademicDataTable.vue?vue&type=script&lang=js&"
export * from "./AcademicDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AcademicDataTable.vue?vue&type=style&index=0&id=21eed57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eed57b",
  null
  
)

export default component.exports